export const loginlessPages = ['/my-rewards', '/my-transactions', '/my-earnings', '/my-pay', '/widget-data-upload'];
